import React, { useContext } from "react"
import { SelectedIcon as SelectedIconType } from "@ecountabl/lib"
import { Platform, StyleSheet, Text, View } from "react-native"
import { ThemeContext } from "../utility/context/ThemeContext"
import SelectedIcon from "./selected-icon"
import { ShadowView, textStyles } from "../style"


type Props = {
  value: string;
  label: string;
  icon?: SelectedIconType;
  containerStyle?: Record<string, unknown>;
}

const ValueLabelCard: React.FC<Props> = ({value, label, icon, containerStyle}: Props) => {
  const theme = useContext(ThemeContext).theme
  const { primary, white, textAlt, bgMain } = theme.colors

  return (
    <ShadowView
      style={[
        styles.card,
        {
          borderColor: primary,
        },
        containerStyle,
      ]}
    >
        <View style={[styles.header, {backgroundColor: primary}]}>
          <View style={{flex: 0.25, justifyContent: "center", alignItems: "center"}}>
            <SelectedIcon
              icon={{name: icon.name, family: icon.family}}
              size={36}
              color={white}
            />
          </View>
          <View style={{flex: 0.5}}>
            <Text
              numberOfLines={1}
              style={[textStyles.h4, {textAlign: "center", fontWeight: "700", color: white}]}
            >
              {value}
            </Text>
          </View>
          <View style={{flex: 0.25}}/>
        </View>
        <View style={[styles.labelContainer, { backgroundColor: bgMain }]}>
          <Text
            numberOfLines={2}
            style={[textStyles.body,{color: textAlt, textAlign: "center"}]}
          >
            {label}
          </Text>
        </View>
    </ShadowView>
  )
}

const styles = StyleSheet.create({
  header: {
    flexDirection: "row",
    alignItems: "center",
    width: "100%",
    paddingVertical: 5,
    height: 50
  },
  card: {
    flexDirection: "column",
    justifyContent: "flex-start",
    borderWidth: 1,
    borderRadius: 10,
    overflow: "hidden",
  },
  labelContainer: {
    flex: Platform.OS === "web" ? 1 : 0,
    alignItems: "center",
    justifyContent: "center",
    padding: 5,
  }
})

export default ValueLabelCard